export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: '__slot:adkeys_header',
        sortField: 'header',
        sortable: false,
        type: 'string',
        useInFilter: true,
    },
    {
        name: 'txt',
        type: 'string',
        useInFilter: true,
    },
    {
        name: 'pos',
        sortField: 'pos',
        type: 'number',
        useInFilter: true,
    },
    {
        name: 'sr',
        sortField: 'sr',
        type: 'sr',
        callback: 'sr',
        useInFilter: true,
    },
    {
        name: 'frequency',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'mincpc',
        sortField: 'cpc_min',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'maxcpc',
        sortField: 'cpc_max',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'competition',
        sortField: 'competition',
        type: 'competition',
        callback: 'competition',
        dataClass: 'ral',
        useInFilter: true
    },
    {
        name: 'serpf',
        sortField: 'serp',
        type: 'string',
        dataClass: 'ral',
        useInFilter: false,
    }
]
